import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Specialties from "@/pages/Specialties";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import AutismLifeSkills from "@/pages/AutismLifeSkills";
import LcswSupervision from "@/pages/LcswSupervision";
import Shop from "@/pages/Shop";
import Explore from "@/pages/Explore";
import ScrollToTop from "@/components/ScrollToTop";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-bone text-ink">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/specialties" element={<Specialties />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/autism-life-skills" element={<AutismLifeSkills />} />
            <Route path="/lcsw-supervision" element={<LcswSupervision />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/explore" element={<Explore />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
